// /* ─────────────────────────────────────────────────────────────
//    vtg-measurements.js
//    Finds the "Size & Measurements" UL and restructures it
//    with a styled grid box. <p>Size & Measurements:</p> untouched.
// ───────────────────────────────────────────────────────────── */

// (function () {

//   /* ── Inject CSS ─────────────────────────────────────────── */
//   var style = document.createElement('style');
//   style.textContent = `
//     .vtg-measurements-list {
//       border: 2px solid #1a1a1a !important;
//       border-radius: 6px !important;
//       padding: 0 !important;
//       list-style: none !important;
//       margin: 10px 0 16px !important;
//       overflow: hidden;
//       box-shadow: 0 2px 8px rgba(0,0,0,0.08);
//       display: grid;
//       grid-template-columns: 1fr 1fr;
//     }
//     .vtg-measurements-list li {
//       display: flex;
//       flex-direction: column;
//       padding: 10px 14px;
//       gap: 3px;
//       border-right: 1px solid #e8e8e8;
//       border-bottom: 1px solid #e8e8e8;
//       background: #fff;
//     }
//     .vtg-measurements-list li:nth-child(even) {
//       border-right: none;
//     }
//     .vtg-measurements-list li:nth-last-child(-n+2) {
//       border-bottom: none;
//     }
//     .vtg-measurements-list li.vtg-meta {
//       grid-column: span 2;
//       flex-direction: row;
//       align-items: center;
//       justify-content: space-between;
//       border-right: none;
//       border-bottom: 1px solid #333;
//       padding: 8px 14px;
//     }
//     .vtg-meas-key {
//       font-size: 9px;
//       font-weight: 700;
//       letter-spacing: .12em;
//       text-transform: uppercase;
//       color: #000;
//       display: block;
//     }
//     .vtg-meas-val {
//       font-size: 15px;
//       font-weight: 800;
//       color: #1a1a1a;
//       display: block;
//     }
//     li.vtg-meta .vtg-meas-key { color: #000; }
//     li.vtg-meta .vtg-meas-val { font-size: 13px; color: #000; }
//     li.vtg-meta .vtg-meta-right { text-align: right; }
//   `;
//   document.head.appendChild(style);

//   /* ── Helpers ─────────────────────────────────────────────── */
//   function esc(s) {
//     return String(s)
//       .replace(/&/g, '&amp;').replace(/</g, '&lt;')
//       .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
//   }

//   function parsePlusLine(text) {
//     var results = [];
//     var cleaned = text.replace(/^[\s+]+/, '');
//     var chunks = cleaned.split(/\s*\+\s*/);
//     chunks.forEach(function (chunk) {
//       chunk = chunk.trim();
//       if (!chunk) return;
//       var ci = chunk.indexOf(':');
//       if (ci > 0) {
//         results.push({
//           key: chunk.slice(0, ci).trim(),
//           val: chunk.slice(ci + 1).trim()
//         });
//       }
//     });
//     return results;
//   }

//   /* ── Main ────────────────────────────────────────────────── */
//   function run() {

//     var descEl = document.querySelector(
//       '.accordion__content.rte, ' +
//       '.accordion__content, '     +
//       '.product__description, '   +
//       '.product-description, '    +
//       '[data-product-description],' +
//       '.product-single__description'
//     );
//     if (!descEl) return;

//     /* Find "Size & Measurements" <p> */
//     var measureP = null;
//     descEl.querySelectorAll('p').forEach(function (p) {
//       if (!measureP) {
//         var t = p.textContent.toLowerCase();
//         if (t.includes('size') && (t.includes('measurement') || t.includes('measure'))) {
//           measureP = p;
//         }
//       }
//     });
//     if (!measureP) return;

//     /* Find the <ul> immediately after it */
//     var targetUL = null;
//     var sib = measureP.nextElementSibling;
//     while (sib) {
//       if (sib.tagName === 'UL') { targetUL = sib; break; }
//       if (sib.tagName === 'P' && !sib.textContent.trim()) { sib = sib.nextElementSibling; continue; }
//       break;
//     }
//     if (!targetUL) return;

//     /* ── Parse existing LI items ── */
//     var metaRows = [], measRows = [];

//     targetUL.querySelectorAll('li').forEach(function (li) {
//       var t = (li.innerText || li.textContent).trim();
//       if (/^recommended size/i.test(t) || /^size on label/i.test(t)) {
//         var ci = t.indexOf(':');
//         if (ci > 0) metaRows.push({ key: t.slice(0, ci).trim(), val: t.slice(ci + 1).trim() });
//         return;
//       }
//       if (t.includes('+')) {
//         parsePlusLine(t).forEach(function (r) { measRows.push(r); });
//         return;
//       }
//       var ci2 = t.indexOf(':');
//       if (ci2 > 0) measRows.push({ key: t.slice(0, ci2).trim(), val: t.slice(ci2 + 1).trim() });
//     });

//     /* ── Parse bare text nodes inside <ul> ── */
//     targetUL.childNodes.forEach(function (node) {
//       if (node.nodeType !== Node.TEXT_NODE) return;
//       var t = node.textContent.trim();
//       if (!t || !t.includes('+')) return;
//       parsePlusLine(t).forEach(function (r) {
//         var exists = measRows.some(function (m) { return m.key === r.key; });
//         if (!exists) measRows.push(r);
//       });
//     });

//     if (!measRows.length && !metaRows.length) return;

//     /* ── Rebuild UL with new structure ── */
//     targetUL.innerHTML = '';
//     targetUL.classList.add('vtg-measurements-list');

//     /* Meta row (Recommended size + Size on label) — dark top bar */
//     if (metaRows.length) {
//       var metaLi = document.createElement('li');
//       metaLi.className = 'vtg-meta';

//       metaRows.forEach(function (r, i) {
//         var div = document.createElement('div');
//         if (i > 0) div.className = 'vtg-meta-right';
//         div.innerHTML =
//           '<span class="vtg-meas-key">' + esc(r.key) + '</span>' +
//           '<span class="vtg-meas-val">' + esc(r.val) + '</span>';
//         metaLi.appendChild(div);
//       });

//       targetUL.appendChild(metaLi);
//     }

//     /* Measurement rows — 2 col grid */
//     measRows.forEach(function (r) {
//       var li = document.createElement('li');
//       li.innerHTML =
//         '<span class="vtg-meas-key">' + esc(r.key) + '</span>' +
//         '<span class="vtg-meas-val">' + esc(r.val) + '</span>';
//       targetUL.appendChild(li);
//     });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', run);
//   } else {
//     run();
//   }

// })();

/* ─────────────────────────────────────────────────────────────
   vtg-measurements.js
   - Recommended size / Size on label  →  as-is (normal li)
   - Pit-to-pit / Shoulder-to-bottom   →  styled border box
   - <p>Size & Measurements:</p>       →  untouched
───────────────────────────────────────────────────────────── */

// (function () {

//   /* ── Inject CSS ─────────────────────────────────────────── */
//   var style = document.createElement('style');
//   style.textContent = `
//     .vtg-meas-box {
//       border: 2px solid #111;
//       border-radius: 4px;
//       padding: 12px 16px;
//       margin: 10px 0 14px;
//       background: #fff;
//     }
//     .vtg-meas-box__row {
//       font-size: 14px;
//       font-weight: 600;
//       color: #111;
//       text-transform: uppercase;
//       letter-spacing: .04em;
//       line-height: 1.8;
//     }
//     .vtg-meas-box__row + .vtg-meas-box__row {
//       border-top: 1px solid #e8e8e8;
//       padding-top: 6px;
//       margin-top: 6px;
//     }
//   `;
//   document.head.appendChild(style);

//   /* ── Helpers ─────────────────────────────────────────────── */
//   function esc(s) {
//     return String(s)
//       .replace(/&/g, '&amp;').replace(/</g, '&lt;')
//       .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
//   }

//   function parsePlusLine(text) {
//     var results = [];
//     var cleaned = text.replace(/^[\s+]+/, '');
//     var chunks = cleaned.split(/\s*\+\s*/);
//     chunks.forEach(function (chunk) {
//       chunk = chunk.trim();
//       if (!chunk) return;
//       var ci = chunk.indexOf(':');
//       if (ci > 0) {
//         results.push({
//           key: chunk.slice(0, ci).trim(),
//           val: chunk.slice(ci + 1).trim()
//         });
//       }
//     });
//     return results;
//   }

//   /* ── Main ────────────────────────────────────────────────── */
//   function run() {

//     var descEl = document.querySelector(
//       '.accordion__content.rte, ' +
//       '.accordion__content, '     +
//       '.product__description, '   +
//       '.product-description, '    +
//       '[data-product-description],' +
//       '.product-single__description'
//     );
//     if (!descEl) return;

//     /* Find "Size & Measurements" <p> */
//     var measureP = null;
//     descEl.querySelectorAll('p').forEach(function (p) {
//       if (!measureP) {
//         var t = p.textContent.toLowerCase();
//         if (t.includes('size') && (t.includes('measurement') || t.includes('measure'))) {
//           measureP = p;
//         }
//       }
//     });
//     if (!measureP) return;

//     /* Find the <ul> immediately after it */
//     var targetUL = null;
//     var sib = measureP.nextElementSibling;
//     while (sib) {
//       if (sib.tagName === 'UL') { targetUL = sib; break; }
//       if (sib.tagName === 'P' && !sib.textContent.trim()) { sib = sib.nextElementSibling; continue; }
//       break;
//     }
//     if (!targetUL) return;

//     /* ── Collect measurement rows only (not meta) ── */
//     var measRows = [];

//     /* From <li> items */
//     targetUL.querySelectorAll('li').forEach(function (li) {
//       var t = (li.innerText || li.textContent).trim();

//       /* Skip Recommended size / Size on label — leave them as-is */
//       if (/^recommended size/i.test(t) || /^size on label/i.test(t)) return;

//       if (t.includes('+')) {
//         parsePlusLine(t).forEach(function (r) { measRows.push(r); });
//         return;
//       }

//       var ci = t.indexOf(':');
//       if (ci > 0) measRows.push({ key: t.slice(0, ci).trim(), val: t.slice(ci + 1).trim() });
//     });

//     /* From bare text nodes inside <ul> */
//     targetUL.childNodes.forEach(function (node) {
//       if (node.nodeType !== Node.TEXT_NODE) return;
//       var t = node.textContent.trim();
//       if (!t || !t.includes('+')) return;
//       parsePlusLine(t).forEach(function (r) {
//         var exists = measRows.some(function (m) { return m.key === r.key; });
//         if (!exists) measRows.push(r);
//       });
//     });

//     if (!measRows.length) return;

//     /* ── Remove bare text nodes from UL (the "+ Pit..." lines) ── */
//     var toRemove = [];
//     targetUL.childNodes.forEach(function (node) {
//       if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
//         toRemove.push(node);
//       }
//     });
//     toRemove.forEach(function (node) { node.parentNode.removeChild(node); });

//     /* ── Remove measurement <li> items from UL ── */
//     targetUL.querySelectorAll('li').forEach(function (li) {
//       var t = (li.innerText || li.textContent).trim();
//       if (/^recommended size/i.test(t) || /^size on label/i.test(t)) return;
//       li.parentNode.removeChild(li);
//     });

//     /* ── Build border box and insert after UL ── */
//     var box = document.createElement('div');
//     box.className = 'vtg-meas-box';

//     measRows.forEach(function (r) {
//       var row = document.createElement('div');
//       row.className = 'vtg-meas-box__row';
//       row.textContent = r.key + ' : ' + r.val;
//       box.appendChild(row);
//     });

//     targetUL.parentNode.insertBefore(box, targetUL.nextSibling);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', run);
//   } else {
//     run();
//   }

// })();

/* ─────────────────────────────────────────────────────────────
   vtg-measurements.js
   ONLY "+ Key: Value" lines go into the border box.
   All <li> items stay as-is untouched.
   <p>Size & Measurements:</p> untouched.
───────────────────────────────────────────────────────────── */

(function () {

  /* ── Inject CSS ─────────────────────────────────────────── */
  var style = document.createElement('style');
  style.textContent = `
    .vtg-meas-box {
      border: 2px solid #111;
      border-radius: 4px;
      padding: 12px 16px;
      margin: 10px 0 14px;
      background: #fff;
    }
    .vtg-meas-box__row {
      font-size: 14px;
      font-weight: 600;
      color: #111;
      text-transform: uppercase;
      letter-spacing: .04em;
      line-height: 1.8;
    }
    .vtg-meas-box__row + .vtg-meas-box__row {
      border-top: 1px solid #e8e8e8;
      padding-top: 6px;
      margin-top: 6px;
    }
  `;
  document.head.appendChild(style);

  /* ── Helper: parse "+ Key: Value + Key2: Value2" ── */
  function parsePlusLine(text) {
    var results = [];
    var cleaned = text.replace(/^[\s+]+/, '');
    var chunks = cleaned.split(/\s*\+\s*/);
    chunks.forEach(function (chunk) {
      chunk = chunk.trim();
      if (!chunk) return;
      var ci = chunk.indexOf(':');
      if (ci > 0) {
        results.push({
          key: chunk.slice(0, ci).trim(),
          val: chunk.slice(ci + 1).trim()
        });
      }
    });
    return results;
  }

  /* ── Main ────────────────────────────────────────────────── */
  function run() {

    var descEl = document.querySelector(
      '.accordion__content.rte, ' +
      '.accordion__content, '     +
      '.product__description, '   +
      '.product-description, '    +
      '[data-product-description],' +
      '.product-single__description'
    );
    if (!descEl) return;

    /* Find "Size & Measurements" <p> */
    var measureP = null;
    descEl.querySelectorAll('p').forEach(function (p) {
      if (!measureP) {
        var t = p.textContent.toLowerCase();
        if (t.includes('size') && (t.includes('measurement') || t.includes('measure'))) {
          measureP = p;
        }
      }
    });
    if (!measureP) return;

    /* Find the <ul> immediately after it */
    var targetUL = null;
    var sib = measureP.nextElementSibling;
    while (sib) {
      if (sib.tagName === 'UL') { targetUL = sib; break; }
      if (sib.tagName === 'P' && !sib.textContent.trim()) { sib = sib.nextElementSibling; continue; }
      break;
    }
    if (!targetUL) return;

    /* ── ONLY collect bare text nodes with "+" ── */
    /* <li> items are completely ignored / left as-is  */
    var measRows = [];
    var plusNodes = [];

    targetUL.childNodes.forEach(function (node) {
      if (node.nodeType !== Node.TEXT_NODE) return;
      var t = node.textContent.trim();
      if (!t || !t.includes('+')) return;
      parsePlusLine(t).forEach(function (r) {
        var exists = measRows.some(function (m) { return m.key === r.key; });
        if (!exists) measRows.push(r);
      });
      plusNodes.push(node); // track for removal
    });

    /* No + lines found → do nothing, exit */
    if (!measRows.length) return;

    /* ── Remove the bare "+ ..." text nodes from UL ── */
    plusNodes.forEach(function (node) {
      node.parentNode.removeChild(node);
    });

    /* ── Build border box and insert after UL ── */
    var box = document.createElement('div');
    box.className = 'vtg-meas-box';

    measRows.forEach(function (r) {
      var row = document.createElement('div');
      row.className = 'vtg-meas-box__row';
      row.textContent = r.key + ' : ' + r.val;
      box.appendChild(row);
    });

    targetUL.parentNode.insertBefore(box, targetUL.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

})();
